import React, { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import styles from '../css/sgnlOpBase.module.css';
import { useNavigate } from 'react-router-dom';
import useNavigation from 'pages/components/UseNavigation';
import { useDashboard } from 'pages/components/DashboardContext';
import { useEffect } from "react";
import EmergencyVehicleChartBasic from 'pages/components/dashboard/SwItsGetEmergencyVehcleChart';
import SwItsEmergencyVehicleLocation from 'pages/components/dashboard/SwItsEmergencyVehicleLocation';
import { SwItsSgnalTotalProvider, SwItsTrafficSgnlBarChart } from 'pages/components/dashboard/SwItsGetHourSnstvSignal';
import VideoModal from "utils/videoModal";
import { useTranslation } from 'react-i18next';
export default function SignalOperationViewTestM() {
	const [videoOpen, setVideoOpen] = useState(false);
	const [videoSrc, setVideoSrc] = useState('');
	const [showLocation, setShowLocation] = useState(false);
	const { t, i18n } = useTranslation();

	useEffect(() => {
		const handleStorageChange = (e) => {
			if (e.key === 'i18nextLng' && e.newValue && e.newValue !== i18n.language) {
				i18n.changeLanguage(e.newValue);
			}
		};

		window.addEventListener('storage', handleStorageChange);
		return () => window.removeEventListener('storage', handleStorageChange);
	}, [i18n]);


	const openSmartWindow = () => {
		// width  = 창 넓이 , height = 창 높이  (필요한 높이 및 길이로 수정하시면 됩니다)
		const newWindow = window.open(
			'http://192.168.0.111:8080/swSmartCrsrd2',
			'smartWindow',
			'width=2400,height=1800,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
		);

		if (newWindow) {
			// 이동 좌표 x축 , y축 이동 
			setTimeout(() => {
				newWindow.moveTo(4000, 2000);
			}, 1000);
		}
	};

	const { mapMessages, clearLastMapMessage } = useDashboard();
	const navigate = useNavigate();
	useNavigation(mapMessages);

	const openVideo = (src) => {
		setVideoSrc(src);
		setVideoOpen(true);
	};

	useEffect(() => {
		if (mapMessages.length > 0) {
			clearLastMapMessage();
		}
	}, [mapMessages]);

	return (
		<Box sx={{ height: '100%', width: '100%' }}>
			<VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} src={videoSrc} />
			<div className={`${(styles.container_sgnlOpBase)} container`}>
				<div className='L_lmr'>
					{/*  왼쪽 위 아래 박스 */}
					<div className='L_3m L_tb'>
						<div className={`${(styles.box_sgnlOpBase)} L_d inner`}>
							<div className={`${(styles.titWrap_sgnlOpBase)} titWrap flx a_center j_spc_btw`}>
								<h2 className={`${(styles.boxTit_sgnlOpBase)} boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-04' }}>{t('SignalOperationTerminal')}</h2>
								<button type="button" className="morebtn" >
									<img src="/images/dashboard/plus.svg" alt="자세히보기" />
								</button>
							</div>
							{/* 컨텐츠 영역 시작*/}
							<div className={`${styles.boxCont_sgnlOpBase} ${styles.L_lr_sgnlOpBase}`}>
								{/* 텍스트박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase} flx flx_col a_center j_center gap20`}>
									<p className={`${styles.boxTxt_1_sgnlOpBase} innerBg flx a_center j_center`}>교차로 신호시간 운영</p>
									<p className={`${styles.boxTxt_1_sgnlOpBase} innerBg flx a_center j_center`}>연동그룹제어</p>
									<p className={`${styles.boxTxt_1_sgnlOpBase} innerBg flx a_center j_center`}>긴급차량서비스 제어</p>
								</div>
								{/* gif박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase}`}>
									<img src='/images/module/signalOperation.png' alt="twin"
										onClick={() => openVideo('/video/signalOp.mp4')}
									></img>
								</div>
							</div>
							{/* 컨텐츠 영역 끝*/}
						</div>
						<div className={`${(styles.box_sgnlOpBase)} L_d inner`}>
							<div className={`${(styles.titWrap_sgnlOpBase)} titWrap flx a_center j_spc_btw`}>
								<h2 className={`${(styles.boxTit_sgnlOpBase)} boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-07' }}>{t('SmartIntersectionOperationTerminal')}</h2>
								<button type="button" className="morebtn"
									style={{ cursor: 'pointer' }}
									onClick={openSmartWindow}>

									<img src="/images/dashboard/plus.svg" alt="자세히보기" />
								</button>
							</div>
							{/* 컨텐츠 영역 시작*/}
							<div className={`${styles.boxCont_sgnlOpBase} ${styles.L_lr_sgnlOpBase}`}>
								{/* 텍스트박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase} flx flx_col a_center j_center gap20`}>
									<p className={`${styles.boxTxt_2_sgnlOpBase} innerBg flx a_center j_center`}>스마트교차로 운영</p>
									<p className={`${styles.boxTxt_2_sgnlOpBase} innerBg flx a_center j_center`}>교차로 LOS 산출</p>
									<p className={`${styles.boxTxt_2_sgnlOpBase} innerBg flx a_center j_center`}>감응신호시스템 운영</p>
									<p className={`${styles.boxTxt_2_sgnlOpBase} innerBg flx a_center j_center`}>교차로 돌발 및 위험행동 검지</p>
								</div>
								{/* gif박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase}`}>
									<img
										src="/images/module/smtrCrsrd.gif"
										alt="smtrCrsrd"
										style={{ cursor: 'pointer' }}
										onClick={openSmartWindow}
									/>
								</div>
							</div>
							{/* 컨텐츠 영역 끝*/}
						</div>
					</div>
					{/*  중앙 위 아래 박스 */}
					<div className='L_3m L_tb'>
						<div className={`${(styles.box_sgnlOpBase)} L_d inner`}>
							<div className={`${(styles.titWrap_sgnlOpBase)} titWrap flx a_center j_spc_btw`}>
								<h2 className={`${(styles.boxTit_sgnlOpBase)} boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-08' }} >{t('DigitalTwinTrafficFlowSimulation')}</h2>
								<button type="button" className="morebtn" >
									<img src="/images/dashboard/plus.svg" alt="자세히보기" />
								</button>
								{/* // onClick={() => openVideo('/video/visim.mp4')}>
								// 	<img src="/images/dashboard/plus.svg" alt="자세히보기" />
								// </button> */}
							</div>
							{/* 컨텐츠 영역 시작*/}
							<div className={`${styles.boxCont_sgnlOpBase} ${styles.L_lr_sgnlOpBase}`}>
								{/* 텍스트박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase}`}>
									<img
										src="/images/module/twin.gif"
										alt="twin"
										style={{ cursor: 'pointer' }}
									/>
								</div>
								{/* gif박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase}`}>
									<img src='/images/module/visim.gif'
										alt="visim"
										style={{ cursor: 'pointer' }}
										onClick={() => openVideo('/video/visim.mp4')}
									/>
								</div>
							</div>
							{/* 컨텐츠 영역 끝*/}
						</div>
						<div className={`${(styles.box_sgnlOpBase)} L_d inner`}>
							<div className={`${(styles.titWrap_sgnlOpBase)} titWrap flx a_center j_spc_btw`}>
								<h2 className={`${(styles.boxTit_sgnlOpBase)} boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05' }}>{t('RealtimeSignalInformationSharing')}</h2>
								<button type="button" className="morebtn" onClick={() => openVideo('/video/signal.mp4')} >
									<img src="/images/dashboard/plus.svg" alt="자세히보기" />
								</button>
							</div>
							{/* 컨텐츠 영역 시작*/}
							<div className={`${styles.boxCont_sgnlOpBase} ${styles.L_lr_sgnlOpBase} flx j_spc_btw`}>
								{/* 텍스트박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase} flx flx_col a_center gap20`}>
									<p className={`${styles.boxTxt_3_sgnlOpBase} innerBg flx a_center j_center`}>신호 정보 개방 매체</p>
									<div className={`${styles.boxTxt_4_sgnlOpBase} innerBg flx flx_col a_center j_center gap40`}>
										<div className='flx a_center j_center gap40'>
											<div className={`${styles.imgBox_sgnlOpBase} flx flx_col a_center j_center gap10`}>
												<p className={`${styles.imgWrap_sgnlOpBase}`}><img src="/images/module/Tmap.png"></img></p>
												<p className={`${styles.imgTxt_sgnlOpBase}`}>Tmap</p>
											</div>
											<div className={`${styles.imgBox_sgnlOpBase} flx flx_col a_center j_center gap10`}>
												<p className={`${styles.imgWrap_sgnlOpBase}`}><img src="/images/module/Naver.png"></img></p>
												<p className={`${styles.imgTxt_sgnlOpBase}`}>네이버 지도</p>
											</div>
											<div className={`${styles.imgBox_sgnlOpBase} flx flx_col a_center j_center gap10`}>
												<p className={`${styles.imgWrap_sgnlOpBase}`}><img src="/images/module/KaKaoMap.png"></img></p>
												<p className={`${styles.imgTxt_sgnlOpBase}`}>카카오맵</p>
											</div>
											<div className={`${styles.imgBox_sgnlOpBase} flx flx_col a_center j_center gap10`}>
												<p className={`${styles.imgWrap_sgnlOpBase}`}><img src="/images/module/KaKaoNav.png"></img></p>
												<p className={`${styles.imgTxt_sgnlOpBase}`}>카카오내비</p>
											</div>
										</div>

									</div>
								</div>
								{/* gif박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase}`}>
									<div className={`${styles.mockupBox_sgnlOpBase}`}>
										<img className={`${styles.phoneImg_sgnlOpBase}`} src='/images/module/kakao.gif'
											alt="kakao"
											style={{ cursor: 'pointer' }}
											onClick={() => openVideo('/video/signal.mp4')}
										/>
										<img className={`${styles.phoneImg_sgnlOpBase}`} src='/images/phone.png'
											alt="mockup"
											onClick={() => openVideo('/video/signal.mp4')}
											style={{ cursor: 'pointer' }}></img>
										{/* </a>  */}
									</div>
								</div>
							</div>
							{/* 컨텐츠 영역 끝*/}
						</div>
					</div>
					{/*  오른쪽 위 아래 박스 */}
					<div className='L_3m L_tb'>
						<div className={`${(styles.box_sgnlOpBase)} L_d inner`}>
							<div className={`${(styles.titWrap_sgnlOpBase)} titWrap flx a_center j_spc_btw`}>
								<h2 className={`${(styles.boxTit_sgnlOpBase)} boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-06' }}>{t('ActuatedSignalSystem')}</h2>
								<button type="button" className="morebtn"  >
									<img src="/images/dashboard/plus.svg"
										style={{ cursor: 'pointer' }}
										onClick={openSmartWindow}
										alt="자세히보기" />
								</button>
							</div>
							<div className={`${styles.boxCont_sgnlOpBase} of_hidden`}>
								<div
									onClick={openSmartWindow}
									style={{ cursor: 'pointer' }}
								>
									<SwItsSgnalTotalProvider>
										<SwItsTrafficSgnlBarChart />
									</SwItsSgnalTotalProvider>
								</div>
							</div>
							{/* 컨텐츠 영역 시작*/}
							<div className={`${styles.boxCont_sgnlOpBase} ${styles.L_lr_sgnlOpBase}`}>
								{/* 텍스트박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase}`}>

								</div>
								{/* gif박스 5비율*/}
								<div className={`${styles.L_l5_sgnlOpBase}`}>

								</div>
							</div>
							{/* 컨텐츠 영역 끝*/}
						</div>
						<div className={`${(styles.box_sgnlOpBase)} L_d inner`}>
							{/* <div className={`${(styles.titWrap_sgnlOpBase)}  titWrap flx a_center j_spc_btw`}>
								<h2 className={`${(styles.boxTit_sgnlOpBase)} boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-02' }}>{t('EmergencyVehicleOperation2')}</h2>
								<button type="button" className="morebtn" onClick={() => navigate('/module/SignalOperationView')} >
									<img src="/images/dashboard/plus.svg" alt="자세히보기" />
								</button>
							</div>
							
							<div className={`${styles.boxCont_sgnlOpBase} of_hidden`}>
								<div
									onClick={() => navigate('/module/SignalOperationView')}
									style={{ cursor: 'pointer' }}
								>
									<EmergencyVehicleChartBasic /> {/* 2025-05-02 임시 - 추후 수정 
								</div>
							</div> */}
							<div className={`${styles.titWrap_sgnlOpBase} titWrap flx a_center j_spc_btw`}>
								<h2 className={`${styles.boxTit_sgnlOpBase} boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-02)' }}>
									{showLocation ? t('긴급차량 위치 분포도') : t('EmergencyVehicleOperation2')}
								</h2>

								<div className="flx a_center gap20">
									<button
										type="button"
										className="srchBtn"
										onClick={() => setShowLocation(!showLocation)}
										style={{ fontSize: '0.9rem' }}
									>
										{showLocation ? t('긴급차량 운행 현황') : t('긴급차량 위치 분포도')}
									</button>

									<button
										type="button"
										className="morebtn"
										onClick={() => navigate('/module/SignalOperationView')}
									>
										<img src="/images/dashboard/plus.svg" alt={t('자세히보기')} />
									</button>
								</div>
							</div>

							<div className={`${styles.boxCont_sgnlOpBase} of_hidden`}>
								<div
									onClick={() => navigate('/module/SignalOperationView')}
									style={{ cursor: 'pointer' }}
								>
									{showLocation ? <SwItsEmergencyVehicleLocation /> : <EmergencyVehicleChartBasic />}
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* 디지털트윈 주석 시작 */}
				{/* <div className={`${(styles.box_sgnlOpBase)} L_d inner`}>
						<div className={`${(styles.titWrap_sgnlOpBase)}  titWrap flx a_center j_spc_btw`}>
							<h2 className={`${(styles.boxTit_sgnlOpBase)} boxTit`}>디지털 트윈</h2>
							<button type="button" className="morebtn" onClick={() => {
									const videoWindow = window.open('', '_blank', 'width=2400,height=1800');
									if (videoWindow) {
										videoWindow.document.write(`
	<html>
		<head><title>Video Player</title></head>
		<body style="margin:0;display:flex;justify-content:center;align-items:center;height:100vh;background-color:#000;">
		<video src="/video/twin.mp4" controls autoplay style="max-width:100%; max-height:100%;" />
		</body>
	</html>
	`);
									}
								}} >
								<img src="/images/dashboard/plus.svg" alt="자세히보기" />
							</button>
						</div>
						<div className={`${(styles.boxCont_sgnlOpBase)}`}>
							{/* <a href="http://192.168.0.111:8080/swSmtCrsrd2" target="_blank">  */}
				{/* 
						</div>
					</div> */}
				{/* 디지털트윈 주석 끝 */}
			</div>
		</Box>
	);
}
